export class ApiResponse {

    success: boolean;

    response: any;

    sid?: any;

    constructor(success: boolean, response: any) {
        this.success = success;
        this.response = response;
    }

    getErrorMessage(fieldName: string): string | null {
        if (this.response.errorMessage && this.response.errorMessage[fieldName]) {
            let firstKey = Object.keys(this.response.errorMessage[fieldName])[0];
            return this.response.errorMessage[fieldName][firstKey];
        }
        return '';

    }

}

/**
 * check are there errorMessages in the response.
 * @param reason
 */
export function getErrorMessagesFromResponse(reason: any) {
    return reason?.response?.errorMessage;
}
